import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class EntryPageService {

    constructor() { }

    //发送是否需要显示入口页 true需要显示 false无需显示
    sendEntryPageShowChange(value: boolean) {
        localStorage.setItem('isShowEntryPage', value ? '1' : '0');
    }

}